(function(){
    'use strict';

    var levelOneItems = $('.smp-navigation-dropdown__item-title');
    var levelTwoItems = $('.nav-item').find('.smp-navigation-dropdown__sub-outer');

    $(window).resize(function() {
        if( $(this).width() >= 1200 ) {
            levelOneItems.removeClass('inactive');
        } else {
            if (levelTwoItems.hasClass('active')) {
                levelOneItems.addClass('inactive');
            }
            
            $('.smp-navigation-dropdown .nav-item__sub').each(function() {
                var levelTwoCurrent = $(this);

                var subNavList = levelTwoCurrent.closest('.smp-navigation-dropdown__sub-outer'),
                    levelThreeList = levelTwoCurrent.find('.smp-navigation-dropdown__super-sub-outer ul');

                subNavList.removeAttr('style');
                levelThreeList.removeAttr('style');

                levelTwoCurrent.unbind('mouseenter mouseleave');
            });
        }
    });

    $('.nav-toggle').on('click', function() {

        var panel = $(this).parents('.nav-item').find('.smp-navigation-dropdown__sub-outer');

        // Close
        if( $(this).hasClass('active') ) {

            panel.removeClass('active');
            $(this).removeClass('active');

        // Open
        } else {

            panel.addClass('active');
            $(this).addClass('active');
        }
    });
    $('.nav-toggle-sub').on('click', function() {
        var panel = $(this).parents('.nav-item__sub').find('.smp-navigation-dropdown__super-sub-outer');
        // Close
        if( $(this).hasClass('active') ) {
            panel.removeClass('active');
            $(this).removeClass('active');

        // Open
        } else {
            panel.addClass('active');
            $(this).addClass('active');
        }
    });

    const expandSubNav = function(levelTwoCurrent, subNavList, subNavInner, levelThreeList, isHigher, newHeight) {
        
        subNavList.removeAttr('style');
        levelThreeList.removeAttr('style');

        if (levelThreeList || levelTwoCurrent.hasClass('hover')) {
            var subNavInnerPaddingTop = parseInt(subNavInner.css('padding-top')),
                subNavInnerPaddingBottom = parseInt(subNavInner.css('padding-bottom')),
                subNavHeight = subNavList.outerHeight(),
                levelThreeListHeight = levelThreeList.height() + subNavInnerPaddingTop  + subNavInnerPaddingBottom;
            
            if (levelThreeListHeight > subNavHeight) {
                isHigher = true;
                newHeight = levelThreeListHeight;
            }

            if (isHigher) {
                subNavList.css('height', newHeight);
            } else {
                subNavList.removeAttr('style');
                levelThreeList.css('height', '100%');
            }
        } else {
            subNavList.removeAttr('style');
            levelThreeList.removeAttr('style');
        }
    }

    // Allow for tabbing - accessibility
    $('.smp-navigation-dropdown .nav-item').each(function() {

        var panel = $(this).find('.smp-navigation-dropdown__sub-outer');

        $(this).keydown(function(e){

            // For when space bar is hit
            if( e.keyCode == 32 ) {
                // Open the dropdown
                if( !panel.hasClass('active')) {

                    panel.addClass('active');
                    panel.siblings().removeClass('active');

                    $(this).addClass('hover');
                    $(this).siblings().removeClass('hover');

                // Close the dropdown
                } else {

                    panel.removeClass('active');
                    $(this).removeClass('hover');
                }

                return false;

            // For when esc is hit
            } else if(e.keyCode == 27) {

                // Close the dropdown
                if( panel.hasClass('active') ) {

                    panel.removeClass('active');
                    $(this).removeClass('hover');
                }

                return false;
            }

        });

    });

    $('.smp-navigation-dropdown .nav-item__sub').each(function() {

        var levelTwoCurrent = $(this);

        var subNavList = levelTwoCurrent.closest('.smp-navigation-dropdown__sub-outer'),
            subNavInner = levelTwoCurrent.closest('.smp-navigation-dropdown__sub-inner'),
            levelThreeList = levelTwoCurrent.find('.smp-navigation-dropdown__super-sub-outer ul'),
            isHigher = false,
            newHeight = 0;

        if ($(window).width() >= 1200) {
            levelTwoCurrent
            .mouseenter(function() { 
                // expand subnav height if lvl-3 items are greater than lvl-2
                expandSubNav(levelTwoCurrent, subNavList, subNavInner, levelThreeList, isHigher, newHeight);
            })
            .mouseleave(function() {
                subNavList.removeAttr('style');
            });
        }


        var levelThreeItems = levelTwoCurrent.find('.smp-navigation-dropdown__super-sub-outer');

        $(this).keydown(function(e){

            // For when space bar is hit
            if( e.keyCode == 32 ) {
                // Open the dropdown
                // for mobile add active class and for desktop add hover class

                if( $(window).width() < 1200 ) {

                    if( !levelThreeItems.hasClass('active')) {
                        levelThreeItems.addClass('active');
                        levelThreeItems.siblings().removeClass('active');
                    } else {
                        levelThreeItems.removeClass('active');
                    }

                    levelOneItems.addClass('inactive');
                    $(this).removeClass('hover');

                    // Close the dropdown
                } else {

                    if( !$(this).hasClass('hover')) {
                        $(this).addClass('hover');
                        $(this).siblings().removeClass('hover');
                    } else {
                        $(this).removeClass('hover');
                    }
                    expandSubNav(levelTwoCurrent, subNavList, subNavInner, levelThreeList, isHigher, newHeight);
                    levelOneItems.removeClass('inactive');
                }

                return false;

            // For when esc is hit
            } else if(e.keyCode == 27) {

                // Close the dropdown
                if( levelThreeItems.hasClass('active')) {
                    levelThreeItems.removeClass('active');
                    levelOneItems.removeClass('inactive');
                   
                }

                if(  $(this).hasClass('hover')) {
                    $(this).removeClass('hover');
                }

                expandSubNav(levelTwoCurrent, subNavList, subNavInner, levelThreeList, isHigher, newHeight);

                return false;
            }

        });

    });

}());
